import { getIn } from 'shared/lib/utils';

const DEFAULT_LANGUAGE = 'en';

const MESSAGES = {
  source: {
    en: 'Source',
    pt: 'Fonte',
  },
  by: {
    en: 'by',
    pt: 'por',
  },
};

// ISO 639-1.
export function i18n(_languageCode, messageId, fallbackMessage) {
  const languageCode = _languageCode || DEFAULT_LANGUAGE;
  const message = getIn(MESSAGES, [messageId, languageCode], fallbackMessage);
  if (!message) {
    console.error(`Missing '${languageCode}' translation for ${messageId}`);
  }
  return message;
}
